import { GoogleLogin } from '@react-oauth/google'
import { GoogleOauthResponse, usePostSiteGoogleOauthMutation } from '../../app/api'
import { useEffect, useRef, useState } from 'react'
import { setSignup } from '../../app/store/reducers/AuthSlice'
import { useAppDispatch } from '../../app/store/hooks/Redux'

const GOOGLE_BUTTON_MAX_WIDTH = 400

export const GoogleButton = () => {
  const [googleOauth] = usePostSiteGoogleOauthMutation()
  const dispatch = useAppDispatch()
  const containerRef = useRef<HTMLDivElement>(null)
  const [width, setWidth] = useState<number>()

  useEffect(() => {
    const element = containerRef.current
    if (!element) return

    const updateWidth = () => {
      setWidth(Math.min(element.offsetWidth, GOOGLE_BUTTON_MAX_WIDTH))
    }

    updateWidth()

    const observer = new ResizeObserver(updateWidth)
    observer.observe(element)

    return () => observer.disconnect()
  }, [])

  return (
    <div ref={containerRef} className={'w-full'} id='googleSignIn'>
      {width !== undefined && (
        <GoogleLogin
          width={width}
          onError={() => {
            console.log('Login Failed')
          }}
          onSuccess={(credentialResponse) => {
            googleOauth({ credential: credentialResponse.credential }).then((result) => {
              const response = result as { data?: GoogleOauthResponse }

              if (response?.data?.success && response.data.data) {
                window.dataLayer = window.dataLayer || []
                window.dataLayer.push({
                  event: 'login',
                  properties: {
                    user_id: response.data.data.id,
                    employee:
                      response.data.data.email.includes('robusta.team') ||
                      response.data.data.email.includes('bluepear.net'),
                    virtual_mode: response.data.data.is_virtual_mode,
                    user_role: response.data.data.is_master ? 'owner' : response.data.data.sub_role,
                  },
                })

                dispatch(setSignup(response.data.data))
              }
            })
          }}
        />
      )}
    </div>
  )
}
